import { Box, Typography } from '@mui/material';

export default function StatCard({ title, value, subtitle }) {
  return (
    <Box
      sx={{
        background: 'linear-gradient(135deg, #9b5de5, #6a4c93)',
        color: '#fff',
        p: 2,
        borderRadius: 3,
        textAlign: 'center',
        display: 'flex',
        height: 100,
        flexDirection: 'column',
        justifyContent: 'space-between',
        minWidth: { xs: '100%', sm: 160 },
      }}
    >
      <Typography variant="subtitle2">{title}</Typography>
      <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
        {value}
      </Typography>
      {subtitle && <Typography variant="body2">{subtitle}</Typography>}
    </Box>
  );
}
